import type Api from '@/types/api'
import * as ISchemaStore from './data'
import * as SchemaOrderVn from './schema.vn'
import { camelizeKeys } from 'humps'

function createMockApi<T extends object>(data?: any) {
  return () =>
    Promise.resolve<Api.IResponse<T>>({
      msg: 'success',
      code: 0,
      data: data ? (camelizeKeys(data) as T) : ({} as T),
    })
}

export function mockStoreListVN() {
  return createMockApi<SchemaOrderVn.IStoreListResponse>({
    total: 14,
    restaurants: [
      {
        foody_service_id: 1,
        store_type: 1,
        store_id: 10020449,
        overtime_order_mode: 0,
        restaurant_id: 2000000321,
        delivery_id: 8778,
        auto_confirmed: 0,
        is_instant_prep: 1,
        name: 'hhx - food - isv',
      },
      {
        foody_service_id: 1,
        store_type: 1,
        store_id: 10020432,
        overtime_order_mode: 0,
        restaurant_id: 2000000311,
        delivery_id: 8768,
        auto_confirmed: 0,
        is_instant_prep: 1,
        name: 'hhx - food - 4116',
      },
      {
        foody_service_id: 1,
        store_type: 1,
        store_id: 10020492,
        overtime_order_mode: 0,
        restaurant_id: 2000000329,
        delivery_id: 8785,
        auto_confirmed: 0,
        is_instant_prep: 1,
        name: 'hhx - food - Xôi',
      },
      {
        foody_service_id: 1,
        store_type: 1,
        store_id: 10020493,
        overtime_order_mode: 0,
        restaurant_id: 2000000330,
        delivery_id: 8786,
        auto_confirmed: 0,
        is_instant_prep: 1,
        name: 'hhx - food - sensitive',
      },
      {
        foody_service_id: 1,
        store_type: 1,
        store_id: 10020420,
        overtime_order_mode: 0,
        restaurant_id: 2000000299,
        delivery_id: 8756,
        auto_confirmed: 1,
        is_instant_prep: 1,
        name: 'hhx - food - coffee',
      },
      {
        foody_service_id: 1,
        store_type: 1,
        store_id: 10020497,
        overtime_order_mode: 0,
        restaurant_id: 2000000334,
        delivery_id: 8790,
        auto_confirmed: 0,
        is_instant_prep: 1,
        name: 'hhx - food - topping',
      },
      {
        foody_service_id: 1,
        store_type: 1,
        store_id: 10020500,
        overtime_order_mode: 0,
        restaurant_id: 2000000337,
        delivery_id: 8793,
        auto_confirmed: 1,
        is_instant_prep: 1,
        name: 'hhx - food - 714',
      },
      {
        foody_service_id: 1,
        store_type: 1,
        store_id: 10020372,
        overtime_order_mode: 0,
        restaurant_id: 2000000276,
        delivery_id: 8734,
        auto_confirmed: 0,
        is_instant_prep: 1,
        name: 'hhx - food - openapi',
      },
      {
        foody_service_id: 1,
        store_type: 1,
        store_id: 10020378,
        overtime_order_mode: 0,
        restaurant_id: 2000000279,
        delivery_id: 8737,
        auto_confirmed: 0,
        is_instant_prep: 1,
        name: 'hhx - food - 自配送',
      },
      {
        foody_service_id: 1,
        store_type: 1,
        store_id: 10020433,
        overtime_order_mode: 0,
        restaurant_id: 2000000312,
        delivery_id: 8769,
        auto_confirmed: 0,
        is_instant_prep: 1,
        name: 'hhx - food - 4118',
      },
      {
        foody_service_id: 1,
        store_type: 1,
        store_id: 10020380,
        overtime_order_mode: 0,
        restaurant_id: 2000000281,
        delivery_id: 8739,
        auto_confirmed: 1,
        is_instant_prep: 1,
        name: 'hhx - food - cake',
      },
      {
        foody_service_id: 1,
        store_type: 1,
        store_id: 10020379,
        overtime_order_mode: 0,
        restaurant_id: 2000000280,
        delivery_id: 8738,
        auto_confirmed: 0,
        is_instant_prep: 1,
        name: 'hhx - food - fruit',
      },
    ],
  })
}

export function mockStoreListID() {
  return createMockApi<ISchemaStore.IStoreListResponse>({
    total: 7,
    stores: [
      {
        id: '30033039',
        name: ' lnn_store_+9_30033039-S',
        is_instant_prep: 1,
        auto_confirmed: 0,
        overtime_order_mode: 0,
        timezone: 'Asia/Jakarta',
        regular_hours: [
          {
            weekday: 1,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 79200,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 2,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 79200,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 3,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 79200,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 4,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 79200,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 5,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 79200,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 6,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 79200,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 7,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 79200,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
        ],
        special_hours: null,
        status: 2,
      },
      {
        id: '30033038',
        name: 'lnn_store_+8_30033038',
        is_instant_prep: 1,
        auto_confirmed: 1,
        overtime_order_mode: 0,
        timezone: 'Asia/Jakarta',
        regular_hours: [
          {
            weekday: 1,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 86399,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 2,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 86399,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 3,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 86399,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 4,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 7200,
                end_relative_sec: 82859,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 5,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 86399,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 6,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 86399,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 7,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 86399,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
        ],
        special_hours: null,
        status: 2,
      },
      {
        id: '30678489',
        name: 'new 30678489',
        is_instant_prep: 1,
        auto_confirmed: 1,
        overtime_order_mode: 0,
        timezone: 'Asia/Makassar',
        regular_hours: [
          {
            weekday: 1,
            config_enabled: 0,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 2,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 86399,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 3,
            config_enabled: 0,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 4,
            config_enabled: 0,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 5,
            config_enabled: 0,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 6,
            config_enabled: 0,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 7,
            config_enabled: 0,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
        ],
        special_hours: null,
        status: 2,
      },
      {
        id: '30678490',
        name: 'new2 30678490',
        is_instant_prep: 1,
        auto_confirmed: 1,
        overtime_order_mode: 0,
        timezone: 'Asia/Makassar',
        regular_hours: [
          {
            weekday: 1,
            config_enabled: 0,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 2,
            config_enabled: 0,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 3,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 86399,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 4,
            config_enabled: 0,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 5,
            config_enabled: 0,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 6,
            config_enabled: 0,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 7,
            config_enabled: 0,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
        ],
        special_hours: null,
        status: 2,
      },
      {
        id: '30043787',
        name: "Sunny's Shop 30043787",
        is_instant_prep: 0,
        auto_confirmed: 1,
        overtime_order_mode: 0,
        timezone: 'Asia/Jakarta',
        regular_hours: [
          {
            weekday: 1,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 86399,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 2,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 86399,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 3,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 86399,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 4,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 86399,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 5,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 86399,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 6,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 86399,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 7,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 86399,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
        ],
        special_hours: null,
        status: 2,
      },
      {
        id: '30152492',
        name: 'super menu 30152492',
        is_instant_prep: 1,
        auto_confirmed: 1,
        overtime_order_mode: 0,
        timezone: 'Asia/Jakarta',
        regular_hours: [
          {
            weekday: 1,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 86399,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 2,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 79259,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 3,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 1,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 4,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 86399,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 5,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 82859,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 6,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 86399,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 7,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 86399,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
        ],
        special_hours: null,
        status: 2,
      },
      {
        id: '30152491',
        name: 'sync new store 30152491',
        is_instant_prep: 1,
        auto_confirmed: 1,
        overtime_order_mode: 0,
        timezone: 'Asia/Jakarta',
        regular_hours: [
          {
            weekday: 1,
            config_enabled: 0,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 2,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 86399,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 3,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 82859,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 4,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 86399,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 5,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 86399,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 6,
            config_enabled: 1,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 82859,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
          {
            weekday: 7,
            config_enabled: 0,
            intervals: [
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
              {
                start_relative_sec: 0,
                end_relative_sec: 0,
              },
            ],
          },
        ],
        special_hours: null,
        status: 2,
      },
    ],
  })
}
